import * as React from "react";
const SvgPriorityHighOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <circle cx={12} cy={19} r={2} />
    <path d="M10 3h4v12h-4z" />
  </svg>
);
export default SvgPriorityHighOutlined;
